/* 全局弹窗文案管理 */
import {
	DEFAULT_HELP,
	LOGIN_HELP,
	REGISTER_HELP,
	USER_INFO,
	HOME_HElP,
	UPLOAD_HELP,
	SCROLL_SUBTITLE,
	MEDIA_PLAY_GAME,
	MEDIA_PLAY_IMAGE,
	MEDIA_PLAY_MUSIC,
	MEDIA_PLAY_TEXT,
	TEMPLATE,
	PARAM_SETTING_DEVICENAME,
	PARAM_SETTING_SCREEN_ANGLE,
	PARAM_SETTING_SCREEN_LIGHT,
	PARAM_SETTING_SCREEN_MODE,
	PARAM_SETTING_SCREEN_TOUCH,
	PARAM_SETTING_APP_SELF,
	PARAM_SETTING_DEVICE_ADMIN,
	PARAM_SETTING_DEVICE_EXAMINE,
	PARAM_SETTING_DEVICE_ID,
	PARAM_SETTING_APP_VERSION,
	SCREEN_SHOT,
	RESET_HELP,
	DEVICE_ADMIN,
	DEVICE_SUPERADMIN,
	DEVICE_COMMONADMIN,
	SERVICE_FEE_HELP,
	UPGRADE_APP_HELP,
	WINDOWS_HELP,
	FREE_BROADCAST_HELP,
	CASH_PRIZE_HELP,
	RAFFLE_HELP,
	VALID_CODE_HELP,
	GET_INVOICE_HELP,
	INVOICES_HELP,
	ACTIVATION_HELP,
	BILL_HELP,
	WX_BIND_HELP,
} from '@/constants/tiptype';

const tipMap = {
	[DEFAULT_HELP]: ['更多帮助，请在“我的”中“使用说明”中查看。'],

	[REGISTER_HELP]: [
		'填写手机号后获取验证码后完成注册。',
		'如果验证码无法收到，可在QQ群220953623咨询。',
		'如果密码遗失，请在登录页面“忘记密码”中重置密码。',
		'注意：密码必须包含字母和数字，不少于6位；用户名不大于8个中文字符。',
	],
	[LOGIN_HELP]: [
		'本客户端，必须在微信公众号中跳转后登录。',
		'首次使用的用户，可以“游客登录”后体验本软件。',
		'“游客”体验后，应尽快正式注册成为用户，以获得更多权限。',
		'正式用户，也可以在电脑端登录https://www.duodongping.com/操作。',
	],
	[HOME_HElP]: [
		'顶部设备名，点击后可选择设备。同一时间仅能操作一台设备。',
		'如果账号下没有设备，请先到“我的”中点击“激活设备”扫描设备屏幕上的二维码完成激活与绑定。',
		'设备名旁边的红灯亮表示设备不在线，绿灯亮表示设备在线。',
		'设备在线时，可在“实时遥控”中操控设备。',
		'点击右上角的设置图标，可以设定设备的更多参数。',
	],

	[UPLOAD_HELP]: [
		'在这里上传图片、视频、音乐到设备上循环播放。',
		'上传后可在“播放·媒体”中查看和编辑。',
		'也可在电脑客户端完成上传和编辑: https://www.duodongping.com。（电脑客户端主要用来批量上传和发布操作。）',
		'注意：大于20M的图片暂无法支持。请等待后续升级。',
		'注意：未续费设备可能无法操作。（可在QQ群220953623咨询。）',
	],
	[SCROLL_SUBTITLE]: [
		'本页面可制作在屏幕上滚动播出的字幕。',
		// '可以选择字体大小、颜色、速度、位置等。',
		'发布后的字幕将默认添加到列表中循环播放。',
		'如果需要字幕连续循环播放，请在字幕列表中开启连播功能。',
		'部分品牌电视机可能不支持浮动字幕的显示，请等待后续版本。',
	],
	[USER_INFO]: [
		'请尽可能准确完整填写您的商户信息，这将帮助我们为您提供更多针对性的服务。',
		'店铺信息缺失将无法使用抽奖游戏的功能。',
	],
	[MEDIA_PLAY_IMAGE]: [
		'列表中显示的内容，表示在屏幕上循环播放的图像节目。',
		'向左滑动单条节目，可永久“移除”该节目；也可暂时“撤下”该节目，以后根据需要再次“展播”它。',
		'每条节目上的“点播”按键，设备在线时，可实时点播该节目。',
		'点击单条节目，“编辑”中可以修改节目的显示标题、播放时长，以及调整它在列表中的播放排序。',
		'右上角的“图像设置”中，“全屏”表示图片或视频会被强制拉伸以覆盖整个屏幕的宽高。',
		'“图像设置”中，“转场效果”表示节目轮播时的效果展示。',
		'“图像设置”中，“停留时间”表示该节目的默认展播时长。',
		'点击浮动的“上传”按键，可上传和发布节目文件到服务器并同步到设备。也可在电脑端网页中完成上传操作。',
		'以上编辑和设置修改后，约十几秒后在设备上生效。',
	],
	[MEDIA_PLAY_TEXT]: [
		'列表中显示的内容，表示当前在屏幕上滚动播放的文字字幕列表。',
		'向左滑动单条节目，可永久“移除”该节目；也可暂时“撤下”该节目，以后根据需要再次“展播”它。',
		'每条节目上的“点播”按键，设备在线时，可实时点播该节目。',
		'点击单条节目，“编辑”中可以修改字幕的内容、颜色，以及调整它在列表中的播放排序。',
		'右上角的“字幕设置”中，可开启或关闭字幕连续播放功能。',
		'“字幕设置”中，可调整字幕默认的显示大小、位置、速度等参数。',
		'点击浮动的“制作”按键，可创建新的字幕添加到列表中显示。',
	],
	[MEDIA_PLAY_MUSIC]: [
		'列表中显示的内容，表示当前在设备上循环播放的音频列表。',
		'向左滑动单条节目，可永久“移除”该节目；也可暂时“撤下”该节目，以后根据需要再次“展播”它。',
		'每条节目上的“点播”按键，设备在线时，可实时点播该节目。',
		'点击单条节目，“编辑”中可以修改节目的显示标题，以及调整它在列表中的播放排序。',
		'右上角的“音乐·广播设置”中，可开启或关闭音频播放功能。',
		'“播放间隔”表示单个节目播放完后等待的间隔时长。',
		'点击浮动的“上传”按键，可上传新的音乐文件到设备上播放。',
	],
	[MEDIA_PLAY_GAME]: [
		'列表中显示的内容，表示您创建的游戏、公告、海报等节目。',
		'这些节目需要“点播”后才能投送到当前的屏幕上显示。',
		'如果是抽奖游戏，点击“编辑”后重新编辑。',
		'向左滑动单条节目，可永久“移除”该节目。',
		'点击浮动的“制作”按键，可跳转到“抽奖游戏”制作页。',
	],
	[TEMPLATE]: [
		'"我的编辑"保留了您以往编辑过的文案，向左滑动可删除。',
		'"公共"是我们为您提供的文案参考。我们会定期增加新的文案推荐。',
	],

	[PARAM_SETTING_DEVICENAME]: [
		'为每台设备设定不同的昵称和头像，便于区分和选择。',
	],
	[PARAM_SETTING_SCREEN_ANGLE]: ['部分硬件不支持横竖屏切换。'],
	[PARAM_SETTING_SCREEN_LIGHT]: ['部分设备(尤其盒子类硬件)不支持亮度调节。'],
	[PARAM_SETTING_SCREEN_MODE]: [
		'“分屏模式”开启后，屏幕会被分割成若干个子区域播放不同类型的媒体文件。',
		'分屏模式和设计，请在电脑端完成。',
	],
	[PARAM_SETTING_SCREEN_TOUCH]: [
		'"触屏功能" 可以通过手指在屏幕上滑动浏览和控制媒体的播放。',
		'请先确保该设备屏幕支持触摸操作。否则请勿开启！',
	],
	[PARAM_SETTING_APP_SELF]: [
		'APP自运行：每次设备开机后软件自动运行。',
		'部分设备不支持软件自运行。',
	],
	[PARAM_SETTING_DEVICE_ADMIN]: [
		'可以为本设备添加和删除管理员。',
		'新增的管理员需要先成功注册账号。',
	],
	[PARAM_SETTING_DEVICE_EXAMINE]: [
		'快速检测设备软件中运行的情况，给出问题提示。',
	],
	[PARAM_SETTING_DEVICE_ID]: ['设备编号是本设备在系统中的唯一编号。'],
	[PARAM_SETTING_APP_VERSION]: ['这里指的是设备上软件的版本。'],
	[SCREEN_SHOT]: [
		'点击"截屏",可查看设备当前显示画面。',
		'截取的画面中暂不包括滚动字幕和视频内容。',
		'受网络速度等影响,需等待数秒后生成画面。',
	],
	[DEVICE_ADMIN]: [
		'本页面显示当前设备的所有管理员。',
		'超级管理员能够添加和删除普通管理员。',
		'普通管理员可以自行解除与当前设备的绑定，解除后自己无法恢复。',
	],
	[DEVICE_SUPERADMIN]: [
		'超级管理员有且只有一个。',
		'超级管理员可将自己的权限"变更"给其他账号。',
		'超级管理员需要先成为普通管理员。',
	],
	[DEVICE_COMMONADMIN]: [
		'普通管理员可以有多个。',
		'普通管理员无法添加和删除同级别管理员。',
	],
	[UPGRADE_APP_HELP]: [
		'点击升级后，设备将自动下载最新版本并启动更新。',
		'您需要在设备上,使用鼠标、键盘、触摸、遥控器等确认安装。',
		'为避免出错，请勿重复点击升级按键。',
		'请选择在设备空闲时进行升级操作。',
		'这里的版本指的是您设备上的APP版本。',
		'多次尝试升级，仍然失败后，建议卸载原有版本，通过之前的渠道重新安装。',
	],
	[WINDOWS_HELP]: [
		'"分屏功能"可以将设备屏幕分割成若干窗口，以播放不同的媒体内容。',
		'"分屏模板"分为横屏和竖屏模板，选择前请确认设备屏幕的旋转角度是否正确。',
		'分屏中的媒体列表来自“媒体·播放”中“图片·视频”的播放列表，修改该播放列表即可改变播放内容。',
		'如果需要自定义的复杂的分屏，请在电脑客户端编辑和发布。',
		'分屏功能属于高级功能，普通用户请谨慎开启。',
	],
	[FREE_BROADCAST_HELP]: [
		'“配音广播”可以选择多种语言种类。',
		'“发音速度”，数值越高，发音速度越快。',
		'“连续播放次数”可设定广播连续播放的次数。',
		'“发布”后需等待数秒开始播放。',
	],
	[CASH_PRIZE_HELP]: [
		'抽奖时，顾客获得的电子奖券可在本页面验证。',
		'奖券仅可以验证一次，验证即表示兑奖，兑奖后将无法二次验证。',
		'验证后的奖券会出现在已兑奖页面中。',
		'验证方法A：您点击右上方的“扫对方”扫描顾客小程序中的二维码，完成验证。',
		'验证方法B：顾客在小程序中点击单个奖券，根据提示扫描本页面中的二维码，完成验证。',
		'验证方法C：顾客在小程序中个根据提示扫描您电脑客户端的兑奖二维码，完成验证。',
	],
	[RAFFLE_HELP]: [
		'"抽奖游戏"可以自由制作一个转盘抽奖，让顾客通过微信控制屏幕上的转盘转动，最终获得对应的奖项。',
		'奖项名由商家自主填写和提供，最少4个，最多10个。',
		'每个奖项都有一个中奖概率（百分数，数字在0~100之间），0表示永远无法抽中该奖项，100表示每次都会抽中该奖项。',
		'根据奖项的大小，可设定不同的中奖概率（比如：“一等奖”中奖概率为5，“二等奖”为15，依次类推。）。但，所有奖项的概率之和必须为100。',
		'必须使用“谢谢参与”表示空白奖项。当有多个“谢谢参与”时，应该与各个中奖奖项交替排列。',
		'“单人单日限抽次数”表示每位顾客每天最多抽奖的次数，默认为1次。',
		'顾客中奖后，会在自己的微信上获得一个电子券，商家通过扫描顾客手机上的电子券二维码验证并兑消该奖券。',
		'商家应合理设定奖项，并真实提供奖品；七月流火仅提供技术和数据支持。一旦发现商家使用本游戏欺诈顾客，将永久取消本功能的使用权！',
		'游戏制作开始前，商家必须先在指定页面填写商家信息！',
		'更多互动游戏正在开发中，敬请期待！',
	],

	[RESET_HELP]: [
		'重置后，本设备的所有数据和管理员信息都会被清空，且无法恢复。',
		'重置后，本设备的服务期也会被清空，请谨慎操作。',
		'仅限本设备的超级管理员才能操作重置。',
	],
	[VALID_CODE_HELP]: [
		'手机验证，用来提高重置操作的安全性，确保是管理员本人的操作。',
	],

	[SERVICE_FEE_HELP]: [
		'试用期或服务期到期后需要续交服务费才能正常使用。支付后，服务期会自动延长。',
		'一次性续交两年或三年服务费可以享受服务期赠送优惠。',
		'如需发票，支付后请在"账单"中"索要发票"中提交。',
		'服务期内，如需更换设备，请至QQ群向管理人员提出申请。',
		'如果不再使用，请先“重置与解绑”设备，之后再从设备端卸载多动屏APP。',
		'如有疑问请到QQ群（220953623）咨询群运营人员。',
	],
	[BILL_HELP]: [
		'列表中，显示在手机微信端对于本设备的支付记录。',
		'如需发票，请点击“索要发票”。',
		'发票需要在支付后的30日内申请。',
	],
	[GET_INVOICE_HELP]: [
		'仅支持全面数字化增值税电子普通发票。',
		'提交时，请确保公司抬头、纳税人识别号、邮箱地址填写无误。',
		'通常，电子发票在5个工作日内开具，并发送到用户的邮箱中。长期未收到的，请在QQ群中咨询运营人员。',
		'当有多张待开发票时，请勾选“合并开票”。这样多条记录可以合并开在一张发票上。',
	],
	[INVOICES_HELP]: [
		'通常，电子发票在5个工作日内开具，并发送到填写的邮箱中。',
		'如果需要批量支付和开具发票的，请在QQ群中咨询管理人员。',
	],
	[ACTIVATION_HELP]: [
		'设备首次启用时，屏幕上会出现4位数字激活码；屏幕中央会出现激活二维码。',
		'有两种方式可以激活设备：数字激活码激活和扫描二维码激活。',
		'方式1：输入屏幕上的4位激活码可以激活和绑定。',
		'方式2：扫描屏幕中央的二维码可以激活与绑定。',
		'设备只能被激活一次。',
		'如需为设备添加其他管理员，可以在设备的“配置与参数”中的“设备管理员”中操作。',
		'个别设备上第一次启用时，未正常出现激活码，请尝试重启软件。',
		'未手机注册的临时用户被限制仅能激活一台设备。',
	],
	[WX_BIND_HELP]: [
		'账号绑定当前个人微信，可以提高操作的安全性和便利性。绑定前，请确保当前微信是用户常用的个人微信。',
		'仅限已绑定的微信号登录，表示如果在他人的微信中无法登陆该账号。',
		'允许免密码登录，表示无需输入账号密码，只要是在自己的微信可以直接登录。',
	],
};
export default tipMap;
